module.exports = function (isMobile, locale) {
  return {
    navList: [{
      name: 'Whole-Home Backup',
      imgSrc: isMobile ? ['solutions_nav_whole_h5.webp', 'solutions_nav_whole_h5.jpg'] : ['solutions_nav_whole.webp', 'solutions_nav_whole.jpg'],
      detLink: "/".concat(locale, "/whole-home-backup-power-solution")
    }, {
      name: 'Mobile/Off-grid Home',
      imgSrc: isMobile ? ['solutions_nav_mm100_h5.webp', 'solutions_nav_mm100_h5.jpg'] : ['solutions_nav_mm100.webp', 'solutions_nav_mm100.jpg'],
      detLink: "/".concat(locale, "/ecoflow-power-kits/series")
    }],
    content: {
      headerData: [{
        type: 'large',
        name: 'Whole-Home Backup Power Solution',
        desc: 'Power Has Never Been This Easy.',
        imgSrc: isMobile ? ['solutions_bg_whole_h5.webp', 'solutions_bg_whole_h5.jpg'] : ['solutions_bg_whole.webp', 'solutions_bg_whole.jpg'],
        detLink: "/".concat(locale, "/whole-home-backup-power-solution")
      }, {
        type: 'large',
        name: 'Mobile/Off-grid Home Power Kits',
        desc: 'Simple. Smart. Compact.',
        imgSrc: isMobile ? ['solutions_bg_h5.webp', 'solutions_bg_h5.jpg'] : ['solutions_bg.webp', 'solutions_bg.jpg'],
        detLink: "/".concat(locale, "/ecoflow-power-kits/series"),
        comLink: 'https://us.ecoflow.com/collections/power-kits-components',
        comText: 'Components'
      }],
      contextList: []
    }
  };
};